//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import hasVideos from '~/mixins/hasVideos'

export default {
  mixins: [hasVideos],

  beforeMount() {
    this.loadMoreVideos()
  },
}
